import * as React from "react";
import { useState } from "react";
import { ChevronsUpDown, Check } from "lucide-react";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList
} from "@/components/ui/command";
import {
  Popover,
  PopoverTrigger,
  PopoverContent
} from "@/components/ui/popover";
import { useKayAuth } from "@/context/AuthContext.js";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Workflow } from "@/types/workflow";

const WorkflowsSwitch = () => {
  const { setWorkflowId, workflowId, workflows } = useKayAuth();
  const [open, setOpen] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");

  const filteredWorkflows = workflows.filter((workflow: Workflow) =>
    workflow.workflow_name?.toLowerCase().includes(search.toLowerCase())
  )

  const handleSelect = (value: string): void => {
    setWorkflowId(value);
    setOpen(false);
  };

  const selectedWorkflow = workflows.find((workflow: Workflow) => workflow.workflow_id === workflowId);

  return (
    <div className="w-full">
      <Popover
        onOpenChange={setOpen}
        open={open}
      >
        <PopoverTrigger asChild>
          <Button
            aria-expanded={open}
            aria-label="Select workflow"
            className="h-9 w-[160px] md:w-[200px] justify-between"
            role="combobox"
            variant="outline"
          >
            <span className="truncate">
              {selectedWorkflow?.workflow_name ?? "Select Workflow"}
            </span>
            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-[300px] p-0 bg-white">
          <Command>
            <CommandInput
              onValueChange={setSearch}
              placeholder="Search workflow..."
              value={search}
            />
            <CommandEmpty>No workflow found.</CommandEmpty>
            <CommandList>
              <CommandGroup heading="Workflows">
                {filteredWorkflows.map((workflow: Workflow) => (
                  <CommandItem
                    key={workflow.workflow_id}
                    onSelect={() => handleSelect(workflow.workflow_id)}
                    value={workflow.workflow_name}
                  >
                    <Check
                      className={cn(
                        "mr-2 h-4 w-4",
                        workflowId === workflow.workflow_id ? "opacity-100" : "opacity-0"
                      )}
                    />
                    {workflow.workflow_name}
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default WorkflowsSwitch